import { defineComponent as P, mergeModels as h, useModel as D, ref as i, onMounted as T, createElementBlock as c, openBlock as t, normalizeClass as q, createCommentVNode as d, createElementVNode as y, renderSlot as B, withDirectives as v, toDisplayString as A, withKeys as F, vModelDynamic as I, createBlock as k, Transition as V, withCtx as C, createVNode as $, vShow as g, withModifiers as K } from "vue";
import { _ as z } from "./UiIconButton.vue_vue_type_script_setup_true_lang-bU5oojc8.js";
import "./style-R_nxVIjQ.js";
const U = {
  class: "ui-input__inner",
  tabindex: "-1"
}, j = {
  key: 0,
  class: "ui-input__label"
}, G = ["type", "placeholder", "disabled", "readonly", "autofocus", "tabindex", "autocomplete", "name", "step"], O = /* @__PURE__ */ P({
  __name: "UiInput",
  props: /* @__PURE__ */ h({
    isDisabled: { type: Boolean },
    placeholder: {},
    label: {},
    size: { default: "md" },
    filled: { type: Boolean },
    error: { type: Boolean },
    disabled: { type: Boolean },
    inside: { type: Boolean },
    type: { default: "text" },
    readonly: { type: Boolean },
    autofocus: { type: Boolean },
    clearable: { type: Boolean },
    isEmptyValueNull: { type: Boolean },
    id: {},
    indexTab: { default: "0" },
    autocomplete: { default: "off" },
    showPassword: { type: Boolean },
    name: {},
    step: { default: "any" }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ h(["change", "clear", "blur", "input"], ["update:modelValue"]),
  setup(b, { expose: E, emit: M }) {
    const a = b, r = M, o = D(b, "modelValue"), p = i(!1), s = i(!1), n = i(), f = i(), m = i();
    function N() {
      p.value = !1, n.value?.blur(), r("blur");
    }
    function R() {
      o.value = a.isEmptyValueNull ? null : "", r("clear");
    }
    function S(e) {
      a.isEmptyValueNull && e.target.value === "" && (o.value = null), r("input", e.target.value);
    }
    function w() {
      a.disabled || a.readonly || (p.value = !0, n.value?.focus());
    }
    return E({
      focus: () => n.value?.focus()
    }), T(() => {
      f.value && a.disabled && f.value.querySelectorAll("button").forEach((e) => e.disabled = !0), m.value && a.disabled && m.value.querySelectorAll("button").forEach((e) => e.disabled = !0);
    }), (e, l) => (t(), c("div", {
      class: q(["ui-input", [
        e.size,
        { "is-focus": p.value },
        { "is-filled": e.filled },
        { "is-disabled": e.disabled },
        { "is-inside": e.inside },
        { "not-empty": !!o.value }
      ]]),
      tabindex: "-1",
      onClick: w
    }, [
      e.$slots.prepend ? (t(), c("div", {
        key: 0,
        ref_key: "prependRef",
        ref: m,
        class: "ui-input__prepend"
      }, [
        B(e.$slots, "prepend")
      ], 512)) : d("", !0),
      y("div", U, [
        e.inside ? (t(), c("span", j, A(e.placeholder), 1)) : d("", !0),
        v(y("input", {
          ref_key: "inputRef",
          ref: n,
          "onUpdate:modelValue": l[0] || (l[0] = (u) => o.value = u),
          class: "ui-input__input",
          type: e.showPassword ? s.value ? "text" : "password" : e.type,
          placeholder: e.inside ? "" : e.placeholder,
          disabled: e.disabled,
          onBlur: N,
          onFocus: w,
          onChange: l[1] || (l[1] = (u) => e.$emit("change")),
          onInput: S,
          onKeydown: l[2] || (l[2] = F((u) => n.value?.blur(), ["esc"])),
          readonly: e.readonly,
          autofocus: e.autofocus,
          tabindex: e.indexTab,
          autocomplete: e.autocomplete,
          name: e.name,
          step: e.step
        }, null, 40, G), [
          [
            I,
            o.value,
            void 0,
            { trim: !0 }
          ]
        ])
      ]),
      y("div", {
        ref_key: "appendRef",
        ref: f,
        class: "ui-input__append"
      }, [
        e.clearable ? (t(), k(V, {
          key: 0,
          name: "fade"
        }, {
          default: C(() => [
            v($(z, {
              "no-size": "",
              size: "sm",
              "icon-color": "var(--color-icon-tertiary)",
              onClick: R,
              "icon-name": "close",
              "icon-type": "400",
              tabindex: "-1"
            }, null, 512), [
              [g, e.clearable && o.value]
            ])
          ]),
          _: 1
        })) : d("", !0),
        e.showPassword ? (t(), k(V, {
          key: 1,
          name: "fade"
        }, {
          default: C(() => [
            v($(z, {
              onClick: l[3] || (l[3] = K((u) => s.value = !s.value, ["stop"])),
              "icon-name": s.value ? "visibility" : "visibility-off",
              "icon-type": "400",
              "icon-color": "var(--color-icon-secondary)",
              "no-size": "",
              size: "sm",
              tabindex: "-1"
            }, null, 8, ["icon-name"]), [
              [g, e.showPassword && o.value]
            ])
          ]),
          _: 1
        })) : d("", !0),
        B(e.$slots, "append")
      ], 512)
    ], 2));
  }
});
export {
  O as _
};
